(function (window, $) {
    var professionSelect = $('#profession-selector');
    var professionsList = $('#professions');
    var addButton = $('#add-profession');
    var professionTemplate = $('#profession-template').detach().removeClass('hide').removeAttr('id');

    init();

    function addCurrentProfession() {
        var exists = professionsList.find('[name="professions[]"][value="' + professionSelect.val() + '"]').length > 0;

        if (exists) {
            return;
        }

        var id = professionSelect.val();

        if (id.length > 0) {
            var profession = professionTemplate.clone();
            var name = professionSelect.find('option:selected').text();
            var experienceInput = profession.find('[name="num_months[:id]"]');

            if (experienceInput.length > 0) {
                professionSelect.val('');
                var inputName = experienceInput.attr('name');
                inputName = inputName.replace(':id', id);
                experienceInput.attr('name', inputName);
            }

            profession.find('.profession-title').text(name);
            profession.find('[name="professions[]"]').val(id);
            professionsList.append(profession);
        }
    }

    function removeProfession(event) {
        $(event.target).closest('li').remove();
    }

    function init() {

        if (professionSelect.length == 0) {
            return;
        }

        addButton.on('click', addCurrentProfession);
        professionsList.on('click', '.remove-profession', removeProfession);
    }

})(window, jQuery);
